/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'

function operateParams (params) {
    for (var i in params) {
        if (params[i] === '') {
            delete params[i]
        }
    }
    return params
}
const url = "/popadmin/admin"


/**
 *修改密码
 *
 * @export
 * @returns
 */
export function updatePassword (params) {
    return httpAgent.POST(`${url}/user/updatePassword`, params)
}
